import apiClient from "@/services/axios";

export const fetchPendingInverseSchedules = (params) =>
  apiClient.get("/compV3/decaissement/encaissement-validation", { params });

export const fetchAllInverseSchedules = (params) =>
  apiClient.get("/compV3/decaissement/encaissement-validation/all", { params });

export const confirmInverseReceipt = (scheduleId, payload) =>
  apiClient.post(
    `/compV3/decaissement/encaissement-validation/${scheduleId}/confirm`,
    { data: payload }
  );

export const fetchEncaissementDetail = (id) =>
  apiClient.get(`/compV3/decaissement/encaissement-validation/${id}/detail`);

export const fetchInverseSchedules = (depenseId) =>
  apiClient.get(
    `/compV3/decaissement/depenses/${depenseId}/inverse-schedules`
  );

export const createInverseSchedules = (depenseId, schedules) =>
  apiClient.post(
    `/compV3/decaissement/depenses/${depenseId}/inverse-schedules`,
    { data: { schedules } }
  );

export const replacePendingInverseSchedules = (depenseId, schedules) =>
  apiClient.put(
    `/compV3/decaissement/depenses/${depenseId}/inverse-schedules/pending-replace`,
    { data: { schedules } }
  );

export const updateInverseSchedule = (id, payload) =>
  apiClient.patch(`/compV3/decaissement/inverse-schedules/${id}`, {
    data: payload,
  });

export const deleteInverseSchedule = (id) =>
  apiClient.delete(`/compV3/decaissement/inverse-schedules/${id}`);
